import { useLoaderData } from '@remix-run/react';
import type { TSurveyElement } from '@shared/dream-components';
import { SurveyElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

import useEmail from '~/hooks/useEmail';
import useSignupRedirects from '~/hooks/useUtils/useSignupRedirects';

import SurveyProvider from './SurveyProvider';

import type { loader } from '~/root';

interface Props {
  node: TSurveyElement;
  children: ReactNode | ReactNode[];
}

const editNode = (node: TSurveyElement) => {
  return {
    ...node,
    attrs: {
      ...node.attrs,
      isSurveyPageForm: true,
    },
  };
};

const Survey = ({ node, children }: Props) => {
  const loaderData = useLoaderData<typeof loader>();
  const publicationId = loaderData?.publication?.id;
  const nodeToRender = editNode(node);
  const [localStorageEmail] = useEmail();
  const { nextPage } = useSignupRedirects();

  const onContinue = () => {
    nextPage();
  };

  const hasEmail = !!localStorageEmail;

  return (
    <SurveyProvider
      hasEmail={hasEmail}
      email={localStorageEmail}
      id={nodeToRender?.attrs?.data?.id}
      publicationId={publicationId}
      successMessage={nodeToRender?.attrs?.data?.thank_you_message}
    >
      {({ isLoading, isSuccess, submittingText }) => (
        <SurveyElement
          element={nodeToRender}
          isSubmitting={isLoading}
          isSuccess={isSuccess}
          isLive
          hasLocalStorageEmail={hasEmail}
          onContinue={onContinue}
          submittingText={submittingText}
        >
          {children}
        </SurveyElement>
      )}
    </SurveyProvider>
  );
};

export default Survey;
